import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, fontSourceSerif4, theme } from "shared/lib/styles";

import { Flag } from "scmp-app/components/content/content-headline/content-headline-tag/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "scmp-app/components/content/content-headline/styles";
import { EntityLink } from "scmp-app/components/entity-link";

import PlusIcon from "./icon-plus.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  inline-size: 100%;
  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Content = styled.div``;

export const StyledEntityLink = styled(EntityLink)`
  margin-block-end: 8px;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 700;

  ${ContentHeadline}, ${Flag} {
    font-weight: 600;
    font-size: 18px;
    font-family: ${fontSourceSerif4};
    line-height: 120%;
    letter-spacing: -0.36px;

    ${theme.breakpoints.up("tablet")} {
      font-size: 20px;
      letter-spacing: -0.4px;
    }
  }

  ${Flag} {
    color: #5a5a5a;
    font-style: italic;
  }

  ${SponsorHeadline} {
    font-size: 18px;
    line-height: 140%;
  }

  ${StyledEntityLink} {
    font-size: 18px;
  }
`;

export const Summary = styled.div`
  margin-block-end: 8px;

  color: #5a5a5a;
  font-weight: 500;
  font-size: 14px;
  font-family: ${fontSourceSerif4};
  font-style: normal;
  line-height: 135%;
  letter-spacing: -0.14px;

  font-feature-settings:
    "clig" off,
    "liga" off;

  &:empty {
    margin: 0;
  }
`;

export const PublishedDate = styled.div`
  color: #5a5a5a;
  font-weight: 400;
  font-size: 11px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
`;

export const StyledCoverEntityLink = styled(EntityLink)`
  aspect-ratio: 260/173;

  position: relative;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 260px;
    block-size: 173px;
  }
`;

export const CoverImage = styled.div`
  position: relative;
  aspect-ratio: 260/173;

  inline-size: 100%;
  block-size: 100%;
`;

export const StyledPlusIcon = styled(PlusIcon)`
  margin-block-end: 8px;
`;

export const SponsorContainer = styled.div`
  inline-size: 100%;
  max-inline-size: 240px;
  margin-block-start: 12px;
  padding-block: 4px;
  padding-inline: 6px;

  border: 1px solid rgba(0, 0, 0, 0.2);
`;

const SponsorTextStyle = css`
  color: #000000;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
`;

export const SponsorType = styled.div`
  ${SponsorTextStyle};
  opacity: 0.5;
`;

export const SponsorName = styled.div`
  ${SponsorTextStyle};
  font-weight: 700;
`;
